import { FETCH_COMPLAINTS_SUCCESS, FETCH_COMPLAINTS_START } from '../actions/actiontypes'

const INIT_STATE = {
	data:{},
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case FETCH_COMPLAINTS_START:{
			return {...state};
		}
		case FETCH_COMPLAINTS_SUCCESS:{
			return {...state, data : action.payload};
		}
		default:
			return state;
	}
}